// src/components/FloatingButton.js
import React from 'react';
import './FloatingButton.css'; // for styling

const FloatingButton = ({ onClick }) => {
    return (
        <button className="floating-button" onClick={onClick} title="Contact Us">
            {/* Replace with any icon you want (FontAwesome, SVG, etc.) */}
            <span>🔗</span>
        </button>
    );
};

export default FloatingButton;
